import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationCenterResponse } from '@/modules/configurationModule/shared/services/configuration.dto'
import { ConfigurationCenterCreateRequest, ConfigurationCenterPatchInBatchRequest } from '@/api/resources/configuration/centersAndAreas/center/configuration-center-services.dto'

class ConfigurationCenterServices {
    async create(request: ConfigurationCenterCreateRequest): Promise<ConfigurationCenterResponse> {
        const response = await axios.post<ConfigurationCenterResponse>(`/configuration/centers`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationCenterResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationCenterResponse>>(`/configuration/centers`, { ...filterModel }, { params })
        return response.data
    }

    async get(centerId: number): Promise<ConfigurationCenterResponse> {
        const response = await axios.get<ConfigurationCenterResponse>(`/configuration/centers/${centerId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/centers/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationCenterPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/centers/batch`, request)
        return response.data
    }
}

export const configurationCenterServices = new ConfigurationCenterServices()
